module.exports = __webpack_public_path__ + "static/media/1011718.f0b8a2f3.png";